/*
  Kiwi Ears · compare page (Rene 2026-08-30) — sections/cmp-tool.

  Pick products, see them side by side.

  IT MOVES CELLS, IT NEVER BUILDS THEM. Every product's row values are rendered
  once by Liquid into a hidden pool, because the values are metafields
  (custom.sound_signature, best_for, standout, drivers) and a JS template
  string cannot read a metafield. That is the same rule that stopped the
  wishlist inventing its own card, and the same pool the finder quiz ranks
  over. Consequence worth knowing: a cell is a single DOM node with one home,
  so the grid is assembled by appending the real nodes in reading order —
  label, then one cell per selected product — and torn down by putting them
  back. A cell can never be in two places.

  ROW DECISIONS, in order:
    · a row where no selected product has a value is dropped entirely — an
      empty band is worse than no band
    · with "Only differences" on, a row where every selection says the same
      thing is dropped too; that is the toggle's whole job
    · rows keep the order Liquid declared them in, never the order the data
      happened to arrive in

  Values come from the product's compare metafields, with the finder's
  editorial layer filling the gaps the catalogue has not filled yet — see
  fillGaps() and the long note in cmp-tool.liquid.

  State lives in the URL (?c=handle,handle) so a comparison survives a reload
  and can be pasted to somebody — the house rule, and the whole point of a
  compare page.
*/
(function () {
  'use strict';
  if (window.__kiwiCompare) return;
  window.__kiwiCompare = true;

  var root = document.querySelector('[data-cmp]');
  if (!root) return;

  var $ = function (s, r) { return (r || root).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || root).querySelectorAll(s)); };

  var MAX = parseInt(root.getAttribute('data-cmp-max'), 10) || 4;
  var pool = $('[data-cmp-pool]');
  var grid = $('[data-cmp-grid]');
  var wrap = $('[data-cmp-tablewrap]');
  var empty = $('[data-cmp-empty]');
  var bar = $('[data-cmp-bar]');
  var chosenList = $('[data-cmp-selected]');
  var countEl = $('[data-cmp-count]');
  var clearBtn = $('[data-cmp-clear]');
  var note = $('[data-cmp-note]');
  var diffOnly = $('[data-cmp-diffonly]');
  var searchEl = $('[data-cmp-search]');
  var noResults = $('[data-cmp-noresults]');
  if (!pool || !grid) return;

  /* handle -> { item, name, cells } */
  var ITEMS = {};
  $$('[data-cmp-item]', pool).forEach(function (n) {
    var cells = {};
    $$('[data-cmp-cell]', n).forEach(function (c) { cells[c.getAttribute('data-cmp-cell')] = c; });
    ITEMS[n.getAttribute('data-handle')] = { node: n, name: n.getAttribute('data-name'), cells: cells };
  });
  /* ------------------------------------------------ the editorial fallback
     The compare metafields are sparsely filled (see the note in
     cmp-tool.liquid: 7 products of 42 for signature, none for drivers), and
     the finder already carries the same facts for 41 of them. A metafield
     always wins; this only writes into a cell the catalogue left empty, and
     only its text — the cell, its classes and its place in the grid are
     server-rendered like every other cell.

     The two label maps mirror assets/kiwi-fndquiz.js. They are duplicated
     rather than shared because they are the FINDER's vocabulary, and this page
     borrowing it is exactly the temporary arrangement the metafield migration
     ends; one file to delete then, not two to keep in step forever. */
  var SOUND = { balanced: 'Balanced', powerful: 'Powerful', vocal: 'Vocal', warm: 'Warm', spacious: 'Spacious' };
  var SCEN = { everyday: 'Everyday music', gaming: 'Gaming', studio: 'Studio monitoring', critical: 'Critical listening', commute: 'Commute & travel', home: 'Home listening', sport: 'Sport & awareness', calls: 'Work & calls', travel: 'Travel', accessory: 'Accessory use' };

  function fillGaps() {
    var node = $('[data-cmp-meta]');
    if (!node) return;
    var META;
    try { META = JSON.parse(node.textContent).products; } catch (e) { return; }
    if (!META) return;

    function words(list, map) {
      if (!list || !list.length) return '';
      return list.map(function (k) { return map[k] || k; }).join(', ');
    }
    Object.keys(ITEMS).forEach(function (h) {
      var m = META[h];
      if (!m) return;   /* unclassified: the row simply stays empty and drops */
      var it = ITEMS[h];
      var from = {
        signature: words(m.sounds, SOUND),
        bestfor: words(m.scen, SCEN),
        standout: m.strength || '',
        drivers: m.sub || '',
        worth: m.tradeoff || ''
      };
      Object.keys(from).forEach(function (k) {
        var cell = it.cells[k];
        if (!cell || cell.textContent.trim() || !from[k]) return;
        cell.textContent = from[k];
      });
    });
  }

  var LABELS = $$('[data-cmp-labels] .cmp-lbl', pool);
  var ROWS = LABELS.map(function (l) { return l.getAttribute('data-cmp-row'); });
  var TILES = $$('[data-cmp-tile]');

  var chosen = [];

  /* ------------------------------------------------------------ url state */
  function readURL() {
    try {
      var v = new URL(window.location.href).searchParams.get('c');
      if (!v) return;
      v.split(',').forEach(function (h) {
        h = h.trim();
        if (h && ITEMS[h] && chosen.indexOf(h) === -1 && chosen.length < MAX) chosen.push(h);
      });
    } catch (e) {}
  }
  function writeURL() {
    try {
      var url = new URL(window.location.href);
      if (chosen.length) url.searchParams.set('c', chosen.join(','));
      else url.searchParams.delete('c');
      history.replaceState({}, '', url);
    } catch (e) {}
  }

  /* -------------------------------------------------------------- assemble */
  function homeCells() {
    /* every borrowed node goes back before the next build, so nothing can be
       claimed by two columns or left behind in a torn-down grid */
    LABELS.forEach(function (l) { $('[data-cmp-labels]', pool).appendChild(l); });
    Object.keys(ITEMS).forEach(function (h) {
      var it = ITEMS[h];
      ROWS.concat(['head']).forEach(function (k) {
        if (it.cells[k]) it.node.appendChild(it.cells[k]);
      });
    });
  }

  function build() {
    homeCells();
    grid.textContent = '';

    if (chosen.length < 2) {
      wrap.hidden = true;
      empty.hidden = false;
      if (note) note.hidden = true;
      return;
    }
    wrap.hidden = false;
    empty.hidden = true;
    if (note) note.hidden = false;

    grid.style.gridTemplateColumns = 'var(--cmp-label) repeat(' + chosen.length + ', minmax(var(--cmp-col), 1fr))';

    /* header row: an empty cell over the label rail, then each product */
    var spacer = document.createElement('div');
    spacer.className = 'cmp-headspacer';
    grid.appendChild(spacer);
    chosen.forEach(function (h) { grid.appendChild(ITEMS[h].cells.head); });

    var onlyDiff = diffOnly && diffOnly.checked;
    LABELS.forEach(function (label, i) {
      var key = ROWS[i];
      var cells = chosen.map(function (h) { return ITEMS[h].cells[key]; });
      if (cells.some(function (c) { return !c; })) return;

      var values = cells.map(function (c) { return c.textContent.trim(); });
      /* nobody has filled this in for anything on screen */
      if (!values.some(function (v) { return v; })) return;
      if (onlyDiff) {
        var same = values.every(function (v) { return v === values[0]; });
        if (same) return;
      }
      grid.appendChild(label);
      cells.forEach(function (c) { grid.appendChild(c); });
    });
  }

  /* ------------------------------------------------------------- controls */
  function paintTiles() {
    var full = chosen.length >= MAX;
    TILES.forEach(function (t) {
      var h = t.getAttribute('data-cmp-tile');
      var on = chosen.indexOf(h) > -1;
      t.setAttribute('aria-pressed', String(on));
      /* at the cap, un-chosen tiles are disabled rather than silently
         ignoring a tap — and the counter beside the label says why */
      t.disabled = full && !on;
    });
    if (countEl) countEl.textContent = chosen.length + ' of ' + MAX;
    if (clearBtn) clearBtn.hidden = chosen.length === 0;
    if (bar) bar.hidden = chosen.length === 0;
  }

  function paintChips() {
    if (!chosenList) return;
    chosenList.textContent = '';
    chosen.forEach(function (h) {
      var li = document.createElement('li');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cmp-selchip';
      b.setAttribute('data-cmp-remove', h);
      b.setAttribute('aria-label', 'Remove ' + ITEMS[h].name + ' from the comparison');
      b.appendChild(document.createTextNode(ITEMS[h].name));
      var x = document.createElement('span');
      x.setAttribute('aria-hidden', 'true');
      x.textContent = '×';
      b.appendChild(x);
      li.appendChild(b);
      chosenList.appendChild(li);
    });
  }

  function render() {
    paintTiles();
    paintChips();
    build();
    writeURL();
  }

  function toggle(handle) {
    var i = chosen.indexOf(handle);
    if (i > -1) chosen.splice(i, 1);
    else {
      if (chosen.length >= MAX) return;
      chosen.push(handle);
    }
    render();
  }

  TILES.forEach(function (t) {
    t.addEventListener('click', function () { toggle(t.getAttribute('data-cmp-tile')); });
  });

  /* remove buttons live in two places — the chips and each table header — and
     both are re-created or re-homed, so this is delegated from the section */
  root.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cmp-remove]');
    if (!b) return;
    e.preventDefault();
    toggle(b.getAttribute('data-cmp-remove'));
  });

  if (clearBtn) clearBtn.addEventListener('click', function () { chosen = []; render(); });
  if (diffOnly) diffOnly.addEventListener('change', build);

  /* ------------------------------------------------------ filter the tiles */
  var typeFilter = '';
  var query = '';
  function filterTiles() {
    var shown = 0;
    TILES.forEach(function (t) {
      var okType = !typeFilter || t.getAttribute('data-type') === typeFilter;
      var okQuery = !query || (t.getAttribute('data-search') || '').indexOf(query) > -1;
      var show = okType && okQuery;
      t.hidden = !show;
      if (show) shown++;
    });
    if (noResults) noResults.classList.toggle('hidden', shown > 0);
  }
  $$('[data-cmp-type]').forEach(function (c) {
    c.addEventListener('click', function () {
      typeFilter = c.getAttribute('data-cmp-type');
      $$('[data-cmp-type]').forEach(function (o) { o.setAttribute('aria-pressed', String(o === c)); });
      filterTiles();
    });
  });
  if (searchEl) {
    searchEl.addEventListener('input', function () {
      query = searchEl.value.trim().toLowerCase();
      filterTiles();
    });
  }

  fillGaps();
  readURL();
  render();
})();
